import moment from 'moment';

export const dateRangeConfiguration: {
  label: string;
  value: string;
  range: { endDate: moment.Moment; startDate: moment.Moment };
}[] = [
  {
    label: 'Today',
    value: 'today',
    range: {
      endDate: moment().endOf('day'),
      startDate: moment().startOf('day'),
    },
  },
  {
    label: 'Yesterday',
    value: 'yesterday',
    range: {
      startDate: moment().subtract(1, 'day').startOf('day'),
      endDate: moment().subtract(1, 'day').endOf('day'),
    },
  },
  {
    label: 'This Week',
    value: 'this_week',
    range: {
      startDate: moment().startOf('week'),
      endDate: moment().endOf('week'),
    },
  },
  {
    label: 'Last Week',
    value: 'last_week',
    range: {
      startDate: moment().subtract(1, 'week').startOf('week'),
      endDate: moment().subtract(1, 'week').endOf('week'),
    },
  },
  {
    label: 'This Month',
    value: 'this_month',
    range: {
      startDate: moment().startOf('month'),
      endDate: moment().endOf('month'),
    },
  },
  {
    label: 'Last Month',
    value: 'last_month',
    range: {
      startDate: moment().subtract(1, 'month').startOf('month'),
      endDate: moment().subtract(1, 'month').endOf('month'),
    },
  },
  {
    label: 'This Quarter',
    value: 'this_quarter',
    range: {
      startDate: moment().startOf('quarter'),
      endDate: moment().endOf('quarter'),
    },
  },
  {
    label: 'Last Quarter',
    value: 'last_quarter',
    range: {
      startDate: moment().subtract(1, 'quarter').startOf('quarter'),
      endDate: moment().subtract(1, 'quarter').endOf('quarter'),
    },
  },
  {
    label: 'This Year',
    value: 'this_year',
    range: {
      startDate: moment().startOf('year'),
      endDate: moment().endOf('year'),
    },
  },
  {
    label: 'Last Year',
    value: 'last_year',
    range: {
      startDate: moment().subtract(1, 'year').startOf('year'),
      endDate: moment().subtract(1, 'year').endOf('year'),
    },
  },
];
